import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { saveTimeRecordError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return ({ timeRecord }) =>
    present(
      repository
        .saveTimeRecord(timeRecord)
        .then((timeRecord) => ({ timeRecord }))
        .catch((error) =>
          Promise.reject({
            timeRecord,
            error: { ...saveTimeRecordError, ...error },
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
